import { dateFormatter } from '../../utils/formaters';
const RepairTableItemDtoToRepairTableItem = (repairTabledto) => repairTabledto?.map(dto => ({
    id: dto.atendimentoId || '-',
    plate: dto.placa || '-',
    status: dto.atendimentoStatus || '-',
    type: dto.motivo || '-',
    scheduleDate: dto.dataAgendamento
        ? dateFormatter(dto.dataAgendamento)
        : '-',
    previsionDate: dto.dataPrevisao ? dateFormatter(dto.dataPrevisao) : '-',
    exitDate: dto.dataSaida ? dateFormatter(dto.dataSaida) : '-',
    situation: dto.situacaoVeiculo || '-',
}));
export const RepairTableDtoToRepairTable = (repairTabledto) => ({
    itens: RepairTableItemDtoToRepairTableItem(repairTabledto.listagem),
    pageCount: repairTabledto.totalPaginas,
    rows: repairTabledto.totalRegistros,
});
const typeDtoToType = (typeDto) => {
    if (typeDto === 'PREVENTIVA')
        return 'preventive';
    if (typeDto === 'CORRETIVA')
        return 'corrective';
    if (typeDto === 'SINISTRO')
        return 'sinister';
    return 'others';
};
const RepairChartItemDtoToRepairChartItem = (repairChartdto) => repairChartdto?.map(dto => ({
    id: dto.dia ? dto.dia : dto.mes,
    type: typeDtoToType(dto.motivo),
    quantity: dto.quantidadeServicos,
}));
export const RepairChartDtoToRepairChart = (repairChartDto) => ({
    itens: RepairChartItemDtoToRepairChartItem(repairChartDto.indicadores),
    count: {
        total: repairChartDto.contagem.total || 0,
        preventive: repairChartDto.contagem.preventiva || 0,
        corrective: repairChartDto.contagem.corretiva || 0,
        sinister: repairChartDto.contagem.sinistra || 0,
        others: repairChartDto.contagem.outros || 0,
    },
});
export const RepairItensDtoToRepairItens = (repairItensDto) => repairItensDto?.map(dto => ({
    type: dto.tipo || '-',
    description: dto.descricao || '-',
    justification: dto.justificativa || '-',
    quantity: dto.quantidade || '-',
}));
export const RepairDetailsDtoToRepairDetails = (repairDetailsDto) => repairDetailsDto.detalhes ? repairDetailsDto.detalhes?.map(dto => dto) : [''];
